import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

export default [
  {
    name: 'click-outside',
    directive: {
      bind(el, binding, vnode) {
        el.clickOutsideEvent = event => {
          // here I check that click was outside the el and his children
          if (!(el === event.target || el.contains(event.target))) {
            // and if it did, call method provided in attribute value
            vnode.context[binding.expression](event);
          }
        };
        document.body.addEventListener('click', el.clickOutsideEvent);
      },
      unbind(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
      },
    },
  },
  {
    name: 'percent',
    directive: {
      bind(el, binding, vnode) {
        const PERCENT_REGEXP = /^\d+[.]{0,1}\d{0,1}/;

        const handler = e => {
          if (!e.target.value) {
            return;
          }

          e.target.value = e.target.value.match(PERCENT_REGEXP)[0];
          vnode.elm.dispatchEvent(new CustomEvent('input'));
        };

        el.addEventListener('input', handler);
        el.$destroy = () => el.removeEventListener('input', handler);
      },
      unbind(el) {
        el.$destroy();
      },
    },
  },
  {
    name: 'maskPrice',
    directive: {
      bind(el, binding, vnode) {
        const regPrice = /^\d+[,.]{0,1}\d{0,2}$/;
        const handler = e => {
          if (!e.target.value) {
            return;
          }

          e.target.value = e.target.value.replace(/\\,/i, '.');

          if (!regPrice.test(e.target.value)) {
            e.target.value = e.target.value.slice(0, -1);
            vnode.elm.dispatchEvent(new CustomEvent('input'));
          }
        };

        el.addEventListener('input', handler);
        el.$destroy = () => el.removeEventListener('input', handler);
      },
      unbind(el) {
        el.$destroy();
      },
    },
  },
  {
    name: 'preventWindowScrolling',
    directive: {
      bind() {
        disableBodyScroll(document.body);
      },
      unbind(el, binding) {
        if (binding.value) {
          return;
        }

        enableBodyScroll(document.body);
      },
    },
  },
  {
    name: 'focus',
    directive: {
      bind(el) {
        el.focus();
      },
    },
  },
  {
    name: 'maxLengthForDateAutocomplete',
    directive: {
      bind(el, binding, vnode) {
        const handler = () => {
          if (!el.value) {
            return;
          }

          if (el.value.length === 4) {
            el.value = el.value.slice(2, 4);
            vnode.elm.dispatchEvent(new CustomEvent('input'));
          } else if (el.value.length > 2) {
            el.value = el.value.slice(0, 2);
            vnode.elm.dispatchEvent(new CustomEvent('input'));
          }
        };

        el.addEventListener('input', handler);
        el.$destroy = () => el.removeEventListener('input', handler);
      },
      unbind(el) {
        el.$destroy();
      },
    },
  },
  {
    name: 'maxLength',
    directive: {
      bind(el, binding, vnode) {
        const handler = () => {
          if (!el.value) {
            return;
          }

          if (el.value.length > binding.value) {
            el.value = el.value.slice(0, binding.value);
            vnode.elm.dispatchEvent(new CustomEvent('input'));
          }
        };

        el.addEventListener('input', handler);
        el.$destroy = () => el.removeEventListener('input', handler);
      },
      unbind(el) {
        el.$destroy();
      },
    },
  },
  {
    name: 'replace',
    directive: {
      bind(el, binding, vnode) {
        const handler = () => {
          if (!el.value) {
            return;
          }

          if (!binding.value.test(el.value)) {
            return;
          }

          el.value = el.value.replace(binding.value, '');
          vnode.elm.dispatchEvent(new CustomEvent('input'));
        };

        el.addEventListener('input', handler);
        el.$destroy = () => el.removeEventListener('input', handler);
      },
      unbind(el) {
        el.$destroy();
      },
    },
  },
  {
    name: 'regexp',
    directive: {
      bind(el, binding, vnode) {
        const handler = () => {
          if (!el.value) {
            return;
          }

          if (!binding.value.test(el.value[el.value.length - 1])) {
            el.value = el.value.slice(0, -1);
            vnode.elm.dispatchEvent(new CustomEvent('input'));
          }
        };

        el.addEventListener('input', handler);
        el.$destroy = () => el.removeEventListener('input', handler);
      },
      unbind(el) {
        el.$destroy();
      },
    },
  },
  {
    name: 'expmask',
    directive: {
      bind(el, binding, vnode) {
        const handler = () => {
          if (!el.value) {
            return;
          }

          const matchValue = el.value.match(binding.value);

          if (el.value.length === 1) {
            const startLetter = /^[a-zA-Z0-9]/.test(el.value);

            if (!startLetter) {
              el.value = el.value.slice(0, -1);
              vnode.elm.dispatchEvent(new CustomEvent('input'));
            }
            return;
          }
          el.value = matchValue[0];
        };

        el.addEventListener('input', handler);
        el.$destroy = () => el.removeEventListener('input', handler);
      },
      unbind(el) {
        el.$destroy();
      },
    },
  },
];
